import React from 'react';
import {actionsState as projectState} from "../Redux/project";
import {actionsState as modulesState} from "../Redux/modules";
import {useDispatch, useSelector} from "react-redux";
import {sendRedrawSimpleEvent, sendUnselectEvent} from "../Helpers/Events";
const ModuleMenu = ({position,module})=>{
    const dispatch = useDispatch();
    const allModules = useSelector(store=>store.modules.allModules);

    const showModuleInfo = ()=>{
        dispatch(projectState.setModal('moduleInfo'))
    }

    const remove = ()=>{
        dispatch(modulesState.remove(module));
        dispatch(modulesState.getPrice());
        sendUnselectEvent(document.querySelector('#plan'));
        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }

    const unselect = ()=>{
        sendUnselectEvent(document.querySelector('#plan'));
        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }

    const copy = ()=>{
        const newModule = JSON.parse(JSON.stringify(allModules.filter(m => m.ID === module.id)[0]))

        dispatch(modulesState.addModule(newModule, module.position, module));
    }

    return <div className="objectMenu">
        <div className="objectMenu-inner-top">
            { module.name }
            <div className="objectMenu-inner-top-unselect" onClick={()=>{unselect()}}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
                    <g stroke="currentColor">
                        <line x1="1" y1="1" x2="18" y2="18"></line>
                        <line x1="18" y1="1" x2="1" y2="18"></line>
                    </g>
                </svg>
            </div>
        </div>
        <div className="objectMenu-inner">
            <div className="objectMenu__item" onClick={()=>{showModuleInfo()}}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="currentColor">
                        <path d="M26,41.22H24a3,3,0,0,1-3-3v-.69a12.88,12.88,0,0,1-2-.84l-.48.49a3,3,0,0,1-4.23,0l-1.44-1.44a3,3,0,0,1,0-4.23L13.3,31a12.88,12.88,0,0,1-.84-2h-.69a3,3,0,0,1-3-3V24a3,3,0,0,1,3-3h.69a12.88,12.88,0,0,1,.84-2l-.49-.48a3,3,0,0,1,0-4.23l1.44-1.44a3,3,0,0,1,4.23,0l.48.49a12.88,12.88,0,0,1,2-.84v-.69a3,3,0,0,1,3-3h2a3,3,0,0,1,3,3v.69a12.88,12.88,0,0,1,2,.84l.48-.49a3,3,0,0,1,4.23,0l1.44,1.44a3,3,0,0,1,0,4.23L36.7,19a12.88,12.88,0,0,1,.84,2h.69a3,3,0,0,1,3,3v2a3,3,0,0,1-3,3h-.69a12.88,12.88,0,0,1-.84,2l.49.48a3,3,0,0,1,0,4.23l-1.44,1.44a3,3,0,0,1-4.23,0L31,36.7a12.88,12.88,0,0,1-2,.84v.69A3,3,0,0,1,26,41.22ZM19.28,34.7a11.49,11.49,0,0,0,2.9,1.21,1,1,0,0,1,.72.92v1.4A1.08,1.08,0,0,0,24,39.32h2a1.08,1.08,0,0,0,1.08-1.09v-1.4a1,1,0,0,1,.72-.92,11.49,11.49,0,0,0,2.9-1.21.94.94,0,0,1,1.15.15l1,1a1.08,1.08,0,0,0,1.53,0l1.44-1.44a1.08,1.08,0,0,0,0-1.53l-1-1a.94.94,0,0,1-.15-1.15,11.49,11.49,0,0,0,1.21-2.9,1,1,0,0,1,.92-.72h1.4A1.08,1.08,0,0,0,39.32,26V24a1.08,1.08,0,0,0-1.09-1.08h-1.4a1,1,0,0,1-.92-.72,11.49,11.49,0,0,0-1.21-2.9.94.94,0,0,1,.15-1.15l1-1a1.08,1.08,0,0,0,0-1.53L34.4,14.16a1.08,1.08,0,0,0-1.53,0l-1,1a.94.94,0,0,1-1.15.15,11.49,11.49,0,0,0-2.9-1.21,1,1,0,0,1-.72-.92v-1.4A1.08,1.08,0,0,0,26,10.68H24a1.08,1.08,0,0,0-1.08,1.09v1.4a1,1,0,0,1-.72.92,11.49,11.49,0,0,0-2.9,1.21.94.94,0,0,1-1.15-.15l-1-1a1.08,1.08,0,0,0-1.53,0L14.16,15.6a1.08,1.08,0,0,0,0,1.53l1,1a.94.94,0,0,1,.15,1.15,11.49,11.49,0,0,0-1.21,2.9,1,1,0,0,1-.92.72h-1.4A1.08,1.08,0,0,0,10.68,24v2a1.08,1.08,0,0,0,1.09,1.08h1.4a1,1,0,0,1,.92.72,11.49,11.49,0,0,0,1.21,2.9.94.94,0,0,1-.15,1.15l-1,1a1.08,1.08,0,0,0,0,1.53l1.44,1.44a1.08,1.08,0,0,0,1.53,0l1-1a.94.94,0,0,1,1.15-.15Z"/>
                        <path d="M25,32.06A7.06,7.06,0,1,1,32.06,25,7.07,7.07,0,0,1,25,32.06Zm0-12.22A5.16,5.16,0,1,0,30.16,25,5.17,5.17,0,0,0,25,19.84Z"/>
                    </g>
                </svg>
            </div>
            <div className="objectMenu__item" onClick={()=>{remove()}}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="currentColor">
                        <path d="M34.82,13.35H29.68v-.93a2.81,2.81,0,0,0-2.81-2.81H23.13a2.81,2.81,0,0,0-2.81,2.81v.93H15.18a2.34,2.34,0,0,0-2.34,2.34V19a.93.93,0,0,0,.93.93h.51l.81,17a2.81,2.81,0,0,0,2.81,2.67H32.1a2.81,2.81,0,0,0,2.81-2.67l.81-17h.51a.93.93,0,0,0,.93-.93V15.69a2.34,2.34,0,0,0-2.34-2.34Zm-12.63-.93a.94.94,0,0,1,.94-.94h3.74a.94.94,0,0,1,.94.94v.93H22.19Zm-7.48,3.27a.47.47,0,0,1,.47-.47H34.82a.47.47,0,0,1,.47.47V18H14.71ZM33,36.79a.94.94,0,0,1-.94.89H17.9a.94.94,0,0,1-.94-.89l-.8-16.89H33.84Z"/>
                        <path d="M25,35.81a.94.94,0,0,0,.94-.94V22.71a.94.94,0,0,0-1.88,0V34.87A.94.94,0,0,0,25,35.81Z"/>
                        <path d="M29.68,35.81a.94.94,0,0,0,.93-.94V22.71a.94.94,0,1,0-1.87,0V34.87A.94.94,0,0,0,29.68,35.81Z"/>
                        <path d="M20.32,35.81a.94.94,0,0,0,.94-.94V22.71a.94.94,0,1,0-1.87,0V34.87A.94.94,0,0,0,20.32,35.81Z"/>
                    </g>
                </svg>
            </div>
            <div className="objectMenu__item" onClick={()=>{copy()}}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.5 19.5" style={{width:'20px',height:'20px'}}>
                    <rect fill="none" stroke="currentColor" x="2" y="0.5" width="17"
                          height="17"/>
                    <path fill="currentColor" d="M0,2.5v17H17V2.5ZM12.75,12H9.5v3.25a1,1,0,0,1-2,0V12H4.25a1,1,0,0,1,0-2H7.5V6.75a1,1,0,0,1,2,0V10h3.25a1,1,0,0,1,0,2Z"/>
                </svg>
            </div>
        </div>
    </div>

}
export default ModuleMenu;
